"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/components/TabFrame.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

// A family's text in the previews.
 const SAMPLE_TEXT = 'Hi, can I move my appointment to Thursday?'; exports.SAMPLE_TEXT = SAMPLE_TEXT

// Every team tab: its settings on the left and, when the team has a number,
// a pinned "What families see" card on the right. Narrow screens stack them.









 const TabFrame = ({ preview, caption, children }) => (
  _react2.default.createElement('div', { className: "team-page--frame", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
    , _react2.default.createElement('div', { className: "team-page--frame-main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}},  children )
    ,  preview && (
      _react2.default.createElement('aside', { className: "team-page--families-see", 'aria-label': "What families see"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
        , _react2.default.createElement('div', { className: "team-page--families-see--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}, "What families see"  )
        ,  preview 
        ,  caption && _react2.default.createElement('div', { className: "team-page--families-see--caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}},  caption ) 
      )
    )
  )
); exports.TabFrame = TabFrame



 const StatusPill = ({ tone, children }) => (
  _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'team-page--pill', `team-page--pill--${tone}`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}},  children )
); exports.StatusPill = StatusPill

// The "⚡ Out-of-office reply" line over a reply the team sends by itself.
 const ReplyTag = ({ children }) => (
  _react2.default.createElement('div', { className: "team-page--reply-tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, "⚡"),  children )
); exports.ReplyTag = ReplyTag








// Picks which case the preview shows, such as Open or Closed.
 const Segmented = ({ label, options, value, onChange }) => (
  _react2.default.createElement('div', { className: "team-page--segmented", role: "group", 'aria-label': label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
    ,  options.map(o => (
      _react2.default.createElement('button', {
        key: o.value,
        type: "button",
        className: _classBuilder2.default.call(void 0, 'team-page--segmented--btn', o.value === value && 'team-page--segmented--btn--active'),
        'aria-pressed': o.value === value,
        onClick: () => onChange(o.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}

        ,  o.label 
      )
    ))
  )
); exports.Segmented = Segmented















// One row of a status list: icon, title and status; it opens in place to
// its settings.
 const StatusRow = ({
  icon, title, status, isMuted, isOpen, onToggle, className, children, ...rest
}) => {
  // A row that closes with focus inside it hands focus back to its header,
  // as a closing dialog returns it to the button that opened it.
  const headRef = _react.useRef(null)
  const bodyRef = _react.useRef(null)
  const hadFocus = _react.useRef.call(void 0, false)
  _react.useEffect.call(void 0, () => {
    const isFocusLost = !document.activeElement || document.activeElement === document.body
    if (!isOpen && hadFocus.current && isFocusLost) _optionalChain([headRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.focus, 'call', _3 => _3()])
    hadFocus.current = false
  }, [isOpen])
  const head = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('span', { className: "team-page--status-row--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}},  icon )
      , _react2.default.createElement('span', { className: "team-page--status-row--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}},  title )
      , _react2.default.createElement('span', { className: "team-page--status-row--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}},  status )
      ,  onToggle && (
        _react2.default.createElement('span', {
          className: _classBuilder2.default.call(void 0, 'team-page--status-row--chevron', isOpen && 'team-page--status-row--chevron--open'),
          'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        )
      )
    )
  )
  return (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 
        'team-page--status-row',
        isOpen && 'team-page--status-row--open',
        isMuted && 'team-page--status-row--muted',
        className,
      ),
      ...rest, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}

      ,  onToggle
        ? (
          _react2.default.createElement('button', {
            ref: headRef,
            type: "button",
            className: "team-page--status-row--head",
            'aria-expanded': !!isOpen,
            onClick: onToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}

            ,  head 
          )
          )
        : _react2.default.createElement('div', { className: "team-page--status-row--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}},  head )
      
      ,  isOpen && (
        _react2.default.createElement('div', {
          ref: bodyRef,
          className: "team-page--status-row--body",
          onFocus: () => { hadFocus.current = true },
          onBlur: (e) => {
            // Focus moving elsewhere clears it; an unmounting control has no target.
            if (e.relatedTarget && !_optionalChain([bodyRef, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.contains, 'call', _6 => _6(e.relatedTarget )])) hadFocus.current = false
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}

          ,  children 
        )
      )
    )
  )
}; exports.StatusRow = StatusRow
